module.exports = __webpack_public_path__ + "static/poppins-v8-latin-regular-46a7d48240d428c9dc3d4ff579199312.woff";